import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export const useReviewStore = create<IReviewStore>()(
  persist(
    (set, get) => ({
      flashcards: [],
      startReviewAt: new Date(),
      qtdFlashcards: 0,
      qtdFlashcardsReviewed: 1,
      currentFlashcard: null,
      decksUuids: [],

      setFlashcards: (flashcards: IFlashcardReview[]) => set({ flashcards }),
      setStartReviewAt: (startReviewAt: Date) => set({ startReviewAt }),
      setQtdFlashcards: (qtdFlashcards: number) => set({ qtdFlashcards }),
      setQtdFlashcardsReviewed: (qtdFlashcardsReviewed: number) =>
        set({ qtdFlashcardsReviewed }),

      setReview: (props: ISetReviewStore) => set(props),

      setNextFlashcard: () => {
        const { currentFlashcard, flashcards, qtdFlashcardsReviewed } = get();

        const currentIndex = flashcards.findIndex(
          (flashcard) =>
            flashcard.flashcardDeckUuid === currentFlashcard?.flashcardDeckUuid
        );
        const nextFlashcard = flashcards[currentIndex + 1];

        if (nextFlashcard) {
          set({
            currentFlashcard: nextFlashcard,
            qtdFlashcardsReviewed: qtdFlashcardsReviewed + 1,
          });
        }
      },

      setResetReview: () => {
        set({
          currentFlashcard: null,
          qtdFlashcardsReviewed: 1,
          qtdFlashcards: 0,
          decksUuids: [],
          startReviewAt: new Date(),
        });
      },
    }),
    {
      name: 'review-flashcards',
    }
  )
);
